import { render, staticRenderFns } from "./TermsContentCN.vue?vue&type=template&id=762b9629&scoped=true"
import script from "./TermsContentCN.vue?vue&type=script&lang=js"
export * from "./TermsContentCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762b9629",
  null
  
)

export default component.exports